import { redirectToLogin } from '../utils/general';
import { getSvocId, getUserId } from '../utils/customer';
import { postCall, getCall } from './axios-client';
import * as samples from '../../mock-data/sso-sample-responses';

const relativeUrl = () => {
  return (
    window.location.protocol + '//' + window.location.host + '/b2b/user'
    + '/account/' + getUserId() + '/customer/' + getSvocId()
  );
};

const loggedIn = () => {
  return (getSvocId() && getUserId());
};

export const getAccountSnapshot = (data) => {
  // return new Promise((resolve, reject) => {
  //   resolve(samples.allAccountsLinked);
  // });
  const url = relativeUrl() + '/sso/account-snapshot';
  return postCall(url, data).then(
    (result) => {
      return result.data;
    },
    (error) => {
      if (error && error.response && (error.response.status === 401)) {
        redirectToLogin();
      }
      return false;
    }
  );
};

// A copy of getAccountSnapshot that can be called for testing unlink
// export const getAccountSnapshotUnlinked = (data) => {
//   return new Promise((resolve, reject) => {
//     resolve(samples.noSsoExists);
//   });
// };

export const getCitiUrl = (siteId, additionalParam = '') => {
  // return new Promise((resolve, reject) => {
  //   resolve(samples.sampleGetUrl);
  // });
  const param = (siteId) ? '&' + additionalParam : '?' + additionalParam;

  const url = relativeUrl() + '/sso/getURL' + (siteId ? '?siteId=' + siteId : '') + (additionalParam ? param : '');

  return getCall(url).then(
    (result) => {
      return result.data;
    },
    (error) => {
      return error;
    }
  );
};

export const delink = (siteId) => {
  // return new Promise((resolve, reject) => {
  //   resolve({ delink: true });
  // });
  const url = relativeUrl() + '/sso/delink' + (siteId ? '?siteId=' + siteId : '');
  return getCall(url).then(
    (result) => {
      return result.data && result.data.delink;
    },
    (error) => {
      if (error && error.response && error.response.status === 401) {
        redirectToLogin();
      }
      return false;
    }
  );
};

export const buildChildRequestObject = (card = {}) => {
  return {
    SnapshotRequest: {
      accountType: card.accountType ? card.accountType : '',
      accounts: [
        {
          accountId: card.accountId ? card.accountId : '',
          accountIndicator: card.parentAccountIndicator === 'Y' ? 'P' : 'S',
        },
      ],
    },
  };
};
